const { $ } = window;

(function main() {
    let secondLevelNavigation;
    let desktopTopNavigation;

    function setScrollStyles(topNavigation, scrollPrevious) {
        const elTop = parseInt(topNavigation.css("top"), 10);
        const scrollCurrent = $(window).scrollTop();
        const scrollDiff = scrollPrevious - scrollCurrent;
        const topNavigationHeight = topNavigation.height() + 2;
        // scrolled to the very top; element sticks to the top
        if (scrollCurrent <= 0) {
            topNavigation.css("top", "");
        } else if (scrollDiff > 0) {
            // scrolled up; element slides in
            topNavigation.css("top", "");
        } else if (scrollDiff < 0) {
            // scrolled down
            // scrolled to the very bottom; element slides in
            if (scrollCurrent + $(window).height() >= $(document).height() - topNavigationHeight) {
                topNavigation.css("top", "");
            } else {
                // scrolled down; element slides out
                // Added -minus 8px so that the gray arrow will also be hidden in mainnavigation
                // eslint-disable-next-line max-len
                const newTopValue = elTop + scrollDiff >= -topNavigationHeight ? elTop + scrollDiff - 8 : -topNavigationHeight - 8;
                topNavigation.css("top", `${newTopValue}px`);
            }
        }
        return scrollCurrent;
    }

    function scrollHide(topNavigation) {
        let wasVisiblePreviously = topNavigation.is(":visible");
        let resizeTimeoutId;
        $(window).resize(() => {
            window.clearTimeout(resizeTimeoutId);
            // eslint-disable-next-line no-use-before-define
            resizeTimeoutId = window.setTimeout(handleWindowResize, 100);
        });

        function handleWindowScroll() {
            // eslint-disable-next-line no-use-before-define
            scrollPrevious = setScrollStyles(topNavigation, scrollPrevious);
        }

        let scrollPrevious = $(window).scrollTop();
        if (topNavigation.is(":visible")) {
            window.addEventListener("scroll", handleWindowScroll);
        }

        // eslint-disable-next-line no-inner-declarations
        function handleWindowResize() {
            const isCurrentlyVisible = topNavigation.is(":visible");
            if (isCurrentlyVisible !== wasVisiblePreviously) {
                if (isCurrentlyVisible) {
                    scrollPrevious = $(window).scrollTop();
                    window.addEventListener("scroll", handleWindowScroll);
                } else {
                    window.removeEventListener("scroll", handleWindowScroll);
                }
            }
            wasVisiblePreviously = isCurrentlyVisible;
        }
    }

    $(document).ready(() => {
        $("nav.site-main-navigation .toggler").on("click", function toggleOpen() {
            $(this).toggleClass("open");
        });
        $("nav.site-main-navigation .mobile-menu").on("click", () => {
            $("nav.site-main-navigation > ul").toggle();
            $("#main-placeholder").toggleClass("mobilefade");
            $("#footer-placeholder").toggleClass("mobilefade");
        });
        $(".mobile-menu-toggler").on("click", () => {
            $("nav.site-main-navigation > ul").toggle();
            $("#main-placeholder").toggleClass("mobilefade");
            $("#footer-placeholder").toggleClass("mobilefade");

            var mobileSearch = document.getElementById("mobile-input-container");
            var mobileLanguage = document.getElementById("mobile-header-language-menu");

            if (!mobileLanguage.classList.contains("show-visibility")) {
                mobileLanguage.classList.toggle("show-visibility");
            }
            
            if (!mobileSearch.classList.contains("show-visibility")) {
                mobileSearch.classList.toggle("show-visibility");
            }
        });

        var pageId = $(".pageId").attr('content');

        $("li[data-pageId=\"" + pageId + "\"]").attr("class", "selected link");

        desktopTopNavigation = $("nav.site-main-navigation").first();
        secondLevelNavigation = $("nav.site-main-navigation > ul li > ul").closest("ul");
        // eslint-disable-next-line max-len
        const isNormalMode = !desktopTopNavigation.hasClass("experience-editor") && !desktopTopNavigation.hasClass("preview");
        if (isNormalMode) {
            scrollHide(desktopTopNavigation);
            scrollHide(secondLevelNavigation);
        }

        document.documentElement.className +=
            (("ontouchstart" in document.documentElement) ? '' : 'hover-enabled');
    });
}());
